<template>
  <div>
    <div class="pxkeji-right-box">
      <pxkeji-btn name="添加" class="pxkeji_basic_btn" @click="showInfo({'id':0})" type="primary" />
      <pxkeji-btn
        name="批量启用"
        @click="batchEnable"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
      />
      <pxkeji-btn
        name="批量禁用"
        @click="batchDisEnable"
        v-if="selectRows.length>0"
        class="pxkeji_basic_btn"
      />

      <a-table
        v-if="infos.type==2"
        rowKey="id"
        :columns="list.columns"
        :dataSource="list.datas"
        :pagination="false"
        :locale="{emptyText:'暂无数据'}"
      >
        <span slot="action" slot-scope="action">
          <pxkeji-btn name="编辑" @click="showInfo(action)" size="small" type="primary" />
          <a-divider type="vertical" />
          <pxkeji-btn name="删除" @click="delInfo(action.id)" size="small" type="default" />
        </span>
      </a-table>

      <a-table
        :columns="list.columns"
        rowKey="id"
        :pagination="list.pagination"
        @change="onChange"
        :dataSource="list.datas"
        :loading="isloading"
        :locale="{emptyText:'暂无数据'}"
        v-else
      >
        <span slot="status" slot-scope="status">
          <a-tag v-if="status" color="green">已启用</a-tag>
          <a-tag v-else color="red">已禁用</a-tag>
        </span>

        <span slot="action" slot-scope="action">
          <pxkeji-btn name="编辑" @click="showInfo(action)" size="small" type="primary" />
          <a-divider type="vertical" />
          <pxkeji-btn name="删除" @click="delInfo(action.id)" size="small" type="default" />
        </span>
      </a-table>
    </div>

    <a-modal
      :title="addedit.title"
      v-model="addedit.visible"
      :footer="false"
      destroyOnClose
      :maskClosable="false"
    >
      <Info @callbackMethod="save" :dinfo="infos" :infos="addedit.info" />
    </a-modal>
  </div>
</template>
<script>
import Info from "./diseaseInfo.vue"; //编辑

const columns = [
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "编号"
  },
  {
    dataIndex: "itemName",
    key: "itemName",
    align: "center",
    title: "名称"
  },

  {
    dataIndex: "itemValue",
    key: "itemValue",
    align: "center",
    title: "字典项值"
  },
  {
    dataIndex: "orderno",
    key: "orderno",
    align: "center",
    title: "排序"
  },
  {
    title: "操作",
    key: "action",
    width: 200,
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

const TreeColumns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name"
  },
  {
    title: "Age",
    dataIndex: "age",
    key: "age",
    width: "12%"
  },
  {
    title: "Address",
    dataIndex: "address",
    width: "30%",
    key: "address"
  }
];

const Treedata = [
  {
    key: 1,
    name: "John Brown sr.",
    age: 60,
    address: "New York No. 1 Lake Park",
    children: [
      {
        key: 11,
        name: "John Brown",
        age: 42,
        address: "New York No. 2 Lake Park"
      },
      {
        key: 12,
        name: "John Brown jr.",
        age: 30,
        address: "New York No. 3 Lake Park",
        children: [
          {
            key: 121,
            name: "Jimmy Brown",
            age: 16,
            address: "New York No. 3 Lake Park"
          }
        ]
      },
      {
        key: 13,
        name: "Jim Green sr.",
        age: 72,
        address: "London No. 1 Lake Park",
        children: [
          {
            key: 131,
            name: "Jim Green",
            age: 42,
            address: "London No. 2 Lake Park",
            children: [
              {
                key: 1311,
                name: "Jim Green jr.",
                age: 25,
                address: "London No. 3 Lake Park"
              },
              {
                key: 1312,
                name: "Jimmy Green sr.",
                age: 18,
                address: "London No. 4 Lake Park"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    key: 2,
    name: "Joe Black",
    age: 32,
    address: "Sidney No. 1 Lake Park"
  }
];

var that;
export default {
  name: "diseaseTypelist",
  props: {
    infos: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      tree: {
        TreeColumns,
        datas: Treedata
      },
      where: {
        //查询条件
        keyword: {
          //搜索条件
          number: "",
          author: "",
          time: ""
        }
      },
      selectRows: [], //选中项编号
      isloading: false,
      info: {
        title: "",
        visible: false,
        id: 0,
        parentid: 0
      },
      addedit: {
        title: "",
        info: {},
        id: 0,
        visible: false
      }
    };
  },
  components: {
    Info
  },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      console.log("列表", this.infos);

      if (this.infos.type == 2) {
        this.GetTree();
      } else {
        this.GetList();
      }
    });
  },
  watch: {
    selectRows: function() {
      //console.log("watch", val);
    }
  },
  methods: {
    toggle() {
      this.expand = !this.expand;
    },
    onTimeChange(date, dateString) {
      this.where.keyword.time = dateString;
    },
    GetList() {
      //获取列表

      this.isloading = true;
      this.clearRows();
      this.$api.dictionaryItem
        .pageList(
          this.list.pagination.current,
          this.list.pagination.defaultPageSize,
          this.infos.id
        )
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data.records;
            this.list.pagination.total = Number(res.data.total);
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    GetTree() {
      //获取列表
      this.isloading = true;
      this.clearRows();
      this.$api.dictionaryItem
        .tree(this.infos.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.list.datas = res.data;
            // this.list.pagination.total = Number(res.data.total);
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },
    onRowChange(selectedRowKeys) {
      //table 多选
      this.selectRows = selectedRowKeys;
    },
    clearRows() {
      //清空选中项
      this.selectRows = [];
    },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    clear() {
      //清空搜索条件
      for (var info in this.where.keyword) {
        this.where.keyword[info] = "";
      }
    },
    showInfo(info) {
      // this.info.title = id ? "编辑" : "添加";
      // this.info.visible = true;
      // this.info.id = id;
      // this.info.type = type;
      this.addedit.visible = true;
      this.addedit.title = info.id ? "编辑" : "新增";
      this.addedit.info = info;
    },
    /*批量启用 */
    batchEnable() {
      this.handleProhibit(this.selectRows.join(","), 1);
    },
    /*批量禁用 */
    batchDisEnable() {
      that.handleProhibit(that.selectRows.join(","), 0);
    },
    /*禁用启用 */
    handleProhibit(ids, status) {
      if (!status) {
        this.$confirm({
          title: "提示",
          content: "您确定要禁用么",
          okText: "确认",
          cancelText: "取消",
          onOk() {
            that.isDisable(ids, status);
          },
          onCancel() {}
        });
      } else {
        that.isDisable(ids, status);
      }
    },
    /**禁用启用的方法 */
    isDisable(ids, status) {
      that.isloading = true;
      that.$api.cms.article
        .updateStatus(ids, status)
        .then(res => {
          that.isloading = false;
          if (res.errorCode == that.$msg.responseCode.success) {
            that.$message.success(res.errorMsg);
            that.GetList();
          } else {
            that.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          that.isloading = false;
        });
    },
    /**删除 */
    delInfo(id) {
      this.$confirm({
        title: "您确定要删除此项吗?",
        okText: "确定",
        okType: "danger",
        cancelText: "我再想想",
        onOk() {
          that.isloading = true;
          that.$api.dictionaryItem
            .del(id)
            .then(res => {
              that.isloading = false;
              if (res.errorCode == that.$msg.responseCode.success) {
                that.$message.success(res.errorMsg);
                that.GetList();
              } else {
                that.$message.error(res.errorMsg);
              }
            })
            .catch(() => {
              that.isloading = false;
            });
        },
        onCancel() {}
      });
    },
    showInfoSupply() {
      //打开弹出框
      this.visibleSupply = true;
    },
    //子组件传值
    save() {
      //this.info.visible = false;
      this.addedit.visible = false;
      if (this.infos.type == 1) {
        this.GetList();
      } else {
        this.GetTree();
      }
    },
    close() {
      this.$confirm({
        title: "提示",
        content: "您确定要禁用么",
        okText: "确认",
        cancelText: "取消"
      });
    }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

